<script setup>
import { defineProps } from "vue";

const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <transition name="fade">
    <div v-if="props.loading" class="loader-overlay">

      <div class="loader-card">

        <img
            class="logo"
            src="https://objectstorage.sa-bogota-1.oraclecloud.com/n/axwjzswungq4/b/Champions_bucket/o/recursos%2Flogo-champions.png"
            alt="Logo"
        />

        <div class="loader">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <p class="loading-text">Cargando información...</p>

      </div>

    </div>
  </transition>
</template>

<style scoped lang="scss">

.loader-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999;

  display: flex;
  justify-content: center;
  align-items: center;

  background:
      linear-gradient(
          135deg,
          #0094DE 0%,
          #0077b6 45%,
          #005f99 100%
      );

  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.loader-card {
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 3rem 4rem;
  border-radius: 24px;

  background: rgba(255, 255, 255, 0.08);

  border: 1px solid rgba(255, 255, 255, 0.15);

  box-shadow:
      0 8px 32px rgba(0, 0, 0, 0.35);

  animation: floatCard 2s ease-in-out infinite;
}

.logo {
  width: 180px;
  max-width: 60vw;
  margin-bottom: 2rem;

  filter: drop-shadow(0 0 12px rgba(255,255,255,.25));
}

.loader {
  display: flex;
  gap: 12px;
  margin-bottom: 1.2rem;
}

.loader span {
  width: 16px;
  height: 16px;
  border-radius: 50%;

  background: #ffffff;

  animation: bounce 0.6s infinite alternate;
}

.loader span:nth-child(2) {
  animation-delay: 0.2s;
}

.loader span:nth-child(3) {
  animation-delay: 0.4s;
}

.loading-text {
  color: white;
  font-size: 1rem;
  letter-spacing: 1px;
  opacity: 0.85;
}

/* ANIMATIONS */

@keyframes bounce {
  from {
    transform: translateY(0);
    opacity: 0.4;
  }

  to {
    transform: translateY(-12px);
    opacity: 1;
  }
}

@keyframes floatCard {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-4px);
  }

  100% {
    transform: translateY(0px);
  }
}

/* TRANSITION */

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.35s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* RESPONSIVE */

@media (max-width: 768px) {

  .loader-card {
    width: 90%;
    padding: 2rem;
  }

  .logo {
    width: 140px;
  }

  .loading-text {
    font-size: 0.9rem;
  }
}
</style>